import React from 'react';
import classNames from 'classnames';
import { IModalBodyForFSP } from '../../../types/properties';
import style from '../../modal.scss';
import * as helper from '../../helper/html-helper';

export const ModalBodyForFSP = (props: IModalBodyForFSP) => {

    function getAltTagValue(): string {
        const categoryName = props.model.categoryName ? ', ' + props.model.categoryName : '';
        const colorName = props.model.colorName ? ', ' + props.model.colorName : '';

        return props.localization.mainView + categoryName + ', ' + props.model.title + colorName;
    }

    const totalImageCount = props.model.imageUrls.length;
    const visibleImagesCount = 3;
    const visibleImages = props.model.imageUrls.slice(0, visibleImagesCount);

    return (
        <div className={style.modal_body}>
            <div className={classNames(style.set_image_container, {
                [style.one_image]: totalImageCount === 1,
                [style.two_images]: totalImageCount === 2,
                [style.three_images]: totalImageCount === 3,
            })}>
                <>
                    { visibleImages.map((url, index) => (
                        <div key={index} className={style.set_image}>
                            <img src={helper.parserImageUrlFSP(url, props.cdnHost)}
                                 alt={getAltTagValue()} />
                        </div>
                    )) }
                    { totalImageCount > 3 &&
                        <div className={style.placeholder_img}>
                            <div className={style.remaining_image_count}>+{totalImageCount - visibleImagesCount}</div>
                        </div>
                    }
                </>
            </div>
            <div className={classNames(style.details_container, style.fsp)}>
                <div className={classNames(style.description, style.fsp)}>
                    {helper.decodeHTML(props.localization.flexSetAddedToBasket)}
                </div>
                <div className={style.article_name}>
                    {props.model.title}
                </div>

                {(props.model && !!props.model.quantity) &&
                    (<div className={style.quantity}>
                        {helper.decodeHTML(props.localization.quantity)}: {props.model.quantity}
                    </div>)}
            </div>
        </div>);
}
